import PropTypes from 'prop-types';

/**
 * @deprecated
 * We no longer use enums for props (so that we don't force the user to import the enum).
 * This enum will remain here for backwards compatibility purposes.
 */
var Variants;
(function (Variants) {
    Variants["TOP"] = "top";
    Variants["TOP_LEFT"] = "topLeft";
    Variants["TOP_RIGHT"] = "topRight";
    Variants["RIGHT"] = "right";
    Variants["RIGHT_TOP"] = "rightTop";
    Variants["RIGHT_BOTTOM"] = "rightBottom";
    Variants["BOTTOM"] = "bottom";
    Variants["BOTTOM_LEFT"] = "bottomLeft";
    Variants["BOTTOM_RIGHT"] = "bottomRight";
    Variants["LEFT"] = "left";
    Variants["LEFT_TOP"] = "leftTop";
    Variants["LEFT_BOTTOM"] = "leftBottom";
})(Variants || (Variants = {}));
var propTypes = {
    tooltipContent: PropTypes.node.isRequired,
    variant: PropTypes.string,
    hideArrow: PropTypes.bool,
    className: PropTypes.string,
    tooltipClassName: PropTypes.string,
    disabled: PropTypes.bool,
    delayShow: PropTypes.number,
    delayHide: PropTypes.number,
    portalTarget: PropTypes.oneOfType([
        PropTypes.instanceOf(Element),
        PropTypes.node,
    ]),
    'data-testid': PropTypes.string,
    children: PropTypes.node,
};
var defaultProps = {
    variant: 'bottom',
    disabled: false,
    hideArrow: false,
    delayShow: 0,
    delayHide: 0,
    'data-testid': 'tooltip',
};
/** Transform variant prop for Popper "placement' equivalent for backwards compatibility
 *  https://popper.js.org/docs/v1/#Popper.placements
 */
var VARIANT_MAP = {
    top: 'top',
    topLeft: 'top-start',
    topRight: 'top-end',
    right: 'right',
    rightTop: 'right-start',
    rightBottom: 'right-end',
    bottom: 'bottom',
    bottomLeft: 'bottom-start',
    bottomRight: 'bottom-end',
    left: 'left',
    leftTop: 'left-start',
    leftBottom: 'left-end',
};
var DEFAULT_MODIFIERS = {
    hide: { enabled: false },
    preventOverflow: { enabled: false },
    flip: { enabled: false },
    arrow: { enabled: false },
};

export { DEFAULT_MODIFIERS, VARIANT_MAP, Variants, defaultProps, propTypes };
